/* ROTAS69 — вынесено из snippets/r69-pdp-badges.liquid.
   Инлайном этот код уезжал в HTML каждой страницы вместе с комментариями;
   assets/*.js Shopify минифицирует и комментарии срезает, а файл кэшируется
   между страницами. Замерено: вынос пяти таких блоков из r69-judgeme дал
   -3..-4 КБ brotli на страницу. Логика не менялась. */

import { StandardEvents } from '@shopify/events';
    (() => {
      const root = document.querySelector('[data-r69-badges]');
      if (!root || root.__r69badges) return;
      root.__r69badges = true;
      const dyn = root.querySelector('[data-r69-badge-dynamic]');
      const dataEl = root.querySelector('[data-r69-badge-variants]');
      if (!dyn || !dataEl) return;
      let MAP = {};
      try { MAP = JSON.parse(dataEl.textContent.trim()); } catch (e) { return; }
      const threshold = parseInt(root.getAttribute('data-threshold') || '0', 10);
      const showNew = root.getAttribute('data-show-new') === '1';
      const showBack = root.getAttribute('data-show-back') === '1';
      const T = {
        soldout: root.getAttribute('data-t-soldout') || '',
        sale: root.getAttribute('data-t-sale') || '',
        knew: root.getAttribute('data-t-new') || '',
        back: root.getAttribute('data-t-back') || '',
        low: root.getAttribute('data-t-low') || '',
      };
      const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
      const badge = (mod, text) => '<div class="product-badges__badge product-badges__badge--rectangle color-custom-badge-' + mod + '">' + text + '</div>';
      const render = (v) => {
        if (!v) return '';
        if (!v.av) return badge('sold-out', esc(T.soldout));
        let html = '';
        if (v.sp > 0) html += badge('sale', esc(T.sale) + ' -' + v.sp + '%');
        if (showNew) html += badge('new', esc(T.knew));
        else if (showBack) html += badge('back', esc(T.back));
        else if (threshold > 0 && v.q != null && v.q > 0 && v.q <= threshold) html += badge('low', esc(T.low));
        return html;
      };
      const liveVid = () => {
        const input = document.querySelector('product-form-component [name="id"], product-information [name="id"], form[action*="/cart/add"] [name="id"]');
        return input && input.value ? String(input.value) : null;
      };
      const applyVid = (vid) => {
        if (!vid || !MAP[vid]) return;
        const html = render(MAP[vid]);
        if (dyn.innerHTML !== html) dyn.innerHTML = html; // idempotent — no-op when unchanged
      };
      const update = () => applyVid(liveVid());
      document.addEventListener(StandardEvents.productSelect, (e) => {
        update(); // instant when the hidden [name="id"] already reflects the pick
        // otherwise settle EXACTLY when the picker resolves the variant — in sync with the price/UI,
        // instead of guessing with fixed 200/500ms timers (which made the badge lag out of sync).
        if (e && e.promise && typeof e.promise.then === 'function') {
          // NOTE: the resolved variant.id is a GID ("gid://shopify/ProductVariant/123"), but MAP is keyed
          // by the plain numeric id — take the last path segment.
          e.promise.then((res) => { const v = res && res.variant; applyVid(v && v.id ? String(v.id).split('/').pop() : liveVid()); }, () => {});
        } else {
          requestAnimationFrame(update);
          setTimeout(update, 350);
        }
      });
      update(); // sync once (covers a ?variant= deep-link differing from the first available)
    })();
